// extracted by mini-css-extract-plugin
export default {"content":"RolesPage_content__o17fi"};